import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, DatePicker } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { defaultValidateMessages } from "./Helper";
import { odata } from "../Filters/Helper";
import moment from "moment";
import IntegerInput from "../../util/IntegerInput";
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const DbsDealerUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    getBanks();
  }, []);

  useEffect(() => {
    if (props.data) {
      if (props.data.limitValidityDate) {
        props.data.limitValidityDate = moment(props.data.limitValidityDate);
      }
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(`/DbsBankInfo/AddedBanks?$select=id,name`).then(
      (response) => {
        setBankSelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const onFirmSeach = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    values.limitValidityDate = values.limitValidityDate
      ? values.limitValidityDate.format("YYYY-MM-DD")
      : null;

    RequestHandler.put(`/DbsDealer`, values)
      .then((response) => {
        setLoading(false);
        if (response.success) {
          form.resetFields();
          if (props.onSuccess) props.onSuccess();
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const onFinishFailed = () => setLoading(false);

  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="dbsDealerUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>

          <Form.Item name="bankId" label="Banka" rules={[{ required: true }]}>
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={bankSelect.loading}
            >
              {bankSelect.data.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Bayi Adı" name="name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item label="Bayi Kodu" name="code" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item label="Cari" name="firmId">
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              onSearch={onFirmSeach}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                option.code
                  ?.toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
              loading={firmSelect.loading}
            >
              {props.data?.firmId && (
                <Select.Option
                  key={props.data.firmId}
                  value={props.data.firmId}
                  code={props.data.firmCode}
                >
                  {props.data.firmName}
                </Select.Option>
              )}
              {firmSelect.data
                .filter((x) => x.id != props.data?.firmId)
                .map((item) => (
                  <Select.Option
                    key={item.id}
                    value={item.id}
                    code={item.firmBranchNumber}
                  >
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item label="Limit Geçerlilik Tarihi" name="limitValidityDate">
            <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
          </Form.Item>

          {props.isUseForErp == true && (
            <Form.Item
              label="Çalışma Sıklığı"
              name="erpDbsDealerWorkingFrequency"
            >
              <Select allowClear>
                <Select.Option key="0" value={0}>
                  Haftalık
                </Select.Option>
                <Select.Option key="1" value={1}>
                  2 Haftalık
                </Select.Option>
                <Select.Option key="2" value={2}>
                  Aylık
                </Select.Option>
              </Select>
            </Form.Item>
          )}

          {props.isUseForErp == true && (
            <Form.Item
              label="Fatura Vade Tarihi Gün Sayısı"
              name="erpDbsDealerWorkingFrequencyNumberOfDays"
            >
              <IntegerInput />
            </Form.Item>
          )}

          {props.isUseForErp == true && (
            <Form.Item
              label="Bayi Banka Hesap Kodu"
              name="erpBankAccountCode"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          )}

          <Form.Item label="Not" name="description">
            <TextArea />
          </Form.Item>

          <Col style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              onClick={() => setLoading(true)}
              loading={loading}
            >
              Güncelle
            </Button>
          </Col>
        </Col>
      </Row>
    </Form>
  );
};
export default DbsDealerUpdateForm;
